import { useEffect } from "react";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { DataModeProvider } from "@/providers/DataModeProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/providers/AuthProvider";
import { configureAuth } from "@/lib/auth-fetch";
import { setApiUrl } from "@/lib/api-config";
import App from "@/App";
import "../globals.css";

interface AppContainerProps {
  settings?: {
    apiUrl?: string;
    clientId?: string;
    defaultUrl?: string;
    identityUrl?: string;
    redirectUri?: string;
    scope?: string;
    workspaceUrl?: string;
  };
}

export default function AppContainer({ settings }: AppContainerProps = {}): React.ReactElement {
  const { getAccessToken, instanceId } = useAuth();

  // Set apiUrl synchronously before render to ensure it's available for API calls
  if (settings?.apiUrl) {
    setApiUrl(settings.apiUrl);
  } 

  useEffect(() => {
    configureAuth({ getAccessToken, instanceId });
  }, [getAccessToken, instanceId]);

    return (
      <QueryProvider>
        <TooltipProvider>
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
            <DataModeProvider>
              <Toaster richColors duration={5000} closeButton />
                <App />
            </DataModeProvider>
          </ThemeProvider>
        </TooltipProvider>
      </QueryProvider>
    );
}
